import { ChevronDownIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import EmojiPicker, { Emoji } from 'emoji-picker-react';
import { Card } from 'react-daisyui';
import { DEFAULT_EMOJI } from '../../Agenda.constants';
import useEmojiPicker from './EmojiPicker.hook';
import './EmojiPicker.styles.scss';
import { tEmojiPickerProps } from './EmojiPicker.types';

export default function EmojiPickerComponent(props: tEmojiPickerProps) {
  const { emoji, inputComponent, handleOnClick } = props;
  const {
    emojiPickerRef,
    showEmojiPicker,
    emojiPickerTheme,
    setShowEmojiPicker,
  } = useEmojiPicker();

  const emojiPickerClassName = classNames({
    EmojiPicker: inputComponent,
  });

  return (
    <div className="relative">
      <div
        className={emojiPickerClassName}
        onClick={() => setShowEmojiPicker(true)}
      >
        <Emoji size={16} unified={emoji ?? DEFAULT_EMOJI.imageUrl} lazyLoad />
        {inputComponent ? <ChevronDownIcon /> : null}
      </div>
      {showEmojiPicker ? (
        <Card.Body ref={emojiPickerRef} className="EmojiPicker__Card">
          <EmojiPicker
            skinTonesDisabled
            lazyLoadEmojis
            height={400}
            theme={emojiPickerTheme}
            onEmojiClick={handleOnClick}
          />
        </Card.Body>
      ) : null}
    </div>
  );
}
